type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  center?: boolean;
  tone?: "default" | "light";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  center = false,
  tone = "default",
}: SectionHeadingProps) {
  const isLight = tone === "light";
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-8 md:mb-12`}>
      <span
        className={`inline-flex items-center gap-2 font-label text-xs md:text-sm tracking-widest uppercase ${
          isLight ? "text-accent-300" : "text-primary-600"
        }`}
      >
        <span className={`h-px w-6 ${isLight ? "bg-accent-400" : "bg-primary-500"}`}></span>
        {eyebrow}
      </span>
      <h2
        className={`mt-3 font-heading text-2xl md:text-4xl font-bold leading-snug ${
          isLight ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc ? (
        <p
          className={`mt-3 text-sm md:text-base leading-relaxed ${
            isLight ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}